import React, {Component} from 'react';
import BKDaneOBilecie from "./BKDaneOBilecie";
import {TopAlertOstrzezenie, TopAlertUwaga} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import BKBiletyPozycje from "./BKBiletyPozycje";
import ReactNotify from "react-notify";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import BKLogiTable from "./BKLogiTable";
import BiletyService from "../../../biletyApi/BiletyService";
import BKWystawioneDokumenty from "./BKWystawioneDokumenty";
import FakturyBiletyService from "../../../fakturyBilety/FakturyBiletyService";
import BKWystawianieFaktury from "./BKWystawianieFaktury";

class BiletKodZParagonuContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bilet: null,
            statusy: [
                {value: -1, label: 'do opłaty', ikona: 'fa fa-times-circle-o', kolor: '#f63a3a'},
                {value: 1, label: 'opłacony', ikona: 'fa fa-check-circle-o', kolor: '#33be3e'},
                {value: 0, label: 'rezerwacja', ikona: 'fa fa-circle-o', kolor: '#21a2ff'},
                {value: 2, label: 'skasowany', ikona: 'fa fa-circle', kolor: '#e4901b'},
                {value: -2, label: 'anulowany przez klienta', ikona: 'fa fa-user-times', kolor: '#772121'},
                {value: -3, label: 'anulowany przez operatora', ikona: 'fa fa-user-secret', kolor: '#772121'},
                {value: -4, label: 'zwrócony', ikona: 'fa fa-refresh', kolor: '#4b4b4b'},
                {value: -5, label: 'nieopłacony', ikona: 'fa fa-times', kolor: '#000'},
                {value: -6, label: 'płatność zwrócona', ikona: 'fa fa-refresh', kolor: '#111'},

            ],
            pokazLogi: false,
            pokazLogiLoader: false,
            logi: [],

            wystawioneDokumenty: [],

        }
    }

    componentDidMount() {
        this.setState({
            bilet: this.props.bilet
        })
        if (Boolean(this.props.bilet)) {
            this.pobierzDokumentyWystawioneNaBiletJednorazowy(this.props.bilet.idBi)
        }
    }

    pobierzDokumentyWystawioneNaBiletJednorazowy = (idBi) => {
        if (Boolean(idBi)) {
            FakturyBiletyService.pobierzFakturyWystawioneNaBiletJednorazowy(idBi).then(response => {
                this.setState({
                    wystawioneDokumenty: response.data,
                })
            })
                .catch(error => {
                    this.wyswietlNotyfikacje("Błąd, nie można pobrać dostępnych faktur na ten bilet jednorazowy", false)
                    console.log(error)
                })
        }

    };

    wyswietlNotyfikacje = (tresc, czySukces = true) => {
        if (czySukces) {
            this.refs.notificator.success(tresc, "", 3000)
        }
        else {
            this.refs.notificator.error(tresc, "", 3000)
        }
    };

    onClickPokazLogi = () => {


        if (this.state.pokazLogi) {
            // wylaczenie
            this.setState({
                pokazLogi: false,
                pokazLogiLoader: false,
                logi: []
            })

        } else {
            //wlaczenie
            this.setState({
                pokazLogi: true,
                pokazLogiLoader: true,
            })


            BiletyService.pokazLogiBiletuPoId(this.state.bilet.idBi).then(function (response) {

                if (response.status < 300) {
                    this.setState({
                        pokazLogiLoader: false,
                        logi: response.data
                    })
                }
                else {
                    this.refs.notificator.error('Nie można wyświetlić logów', "", 3000)
                    this.setState({
                        pokazLogiLoader: false
                    })
                }


            }.bind(this)).catch(function (error) {
                this.refs.notificator.error('Nie można wyświetlić logów', "", 3000)
                this.setState({
                    pokazLogiLoader: false
                })
            }.bind(this))

        }


    };

    render() {
        const {bilet, statusy, wystawioneDokumenty} = this.state;
        if (bilet)
            return (
                <div style={{padding: '0 15px 100px 15px', maxHeight: '70vh', overflowY: 'auto'}}>
                    <ReactNotify ref='notificator'/>
                    <h4 style={{textAlign: 'left', borderBottom: '1px solid #ccc'}}>Podstawowe informacje</h4>
                    <BKDaneOBilecie bilet={bilet} statusy={statusy}/>
                    <BKBiletyPozycje bilet={bilet} statusy={statusy} wyswietlNotyfikacje={this.wyswietlNotyfikacje}/>

                    {/* logi */}
                    <div>
                        <h4 style={{textAlign: 'left', borderBottom: '1px solid #ccc', marginTop: '25px'}}>Logi biletu i płatności</h4>
                        <TopButtonAction iconType={this.state.pokazLogi ? "fa fa-eye-slash" : "fa fa-eye"}
                                         text={this.state.pokazLogi ? "Ukryj logi" : "Pokaż logi"}
                                         onClick={() => this.onClickPokazLogi()}/>
                        <TopIf isTrue={this.state.pokazLogiLoader}>
                                        <span style={{display: "inline-block", marginLeft: "15px"}}>
                                            <span id={'simple-small-loader'} style={{fontSize: "14px", fontWeight: "bold", lineHeight: "30px"}}>
                                                                <i className={'fa fa-spinner fa-spin'}></i> TRWA ŁADOWANIE
                                            </span>
                                        </span>
                        </TopIf>
                        {
                            Boolean(this.state.pokazLogi) ?
                                <div>
                                    {
                                        (this.state.pokazLogiLoader) ?
                                            ""
                                            :
                                            <div>
                                                <BKLogiTable logi={this.state.logi}/>
                                            </div>
                                    }


                                </div>
                                :
                                ""

                        }
                    </div>
                    <h4 style={{textAlign: 'left', borderBottom: '1px solid #ccc', marginTop: '25px'}}>Wystawione dokumenty</h4>
                    <BKWystawioneDokumenty dokumenty={wystawioneDokumenty} bilet={bilet}/>

                    <h4 style={{textAlign: 'left', borderBottom: '1px solid #ccc', marginTop: '25px'}}>Formularz do wystawienia faktury</h4>
                    {
                        bilet.statBil > 0 ?
                            <BKWystawianieFaktury bilet={bilet}
                                                  pobierzPonownieWystawioneDokumenty={() => this.pobierzDokumentyWystawioneNaBiletJednorazowy(bilet.idBi)}/>
                            :
                            <TopAlertOstrzezenie text={'Nie można wystawić faktury na ten bilet - status biletu musi być opłacony badź skasowany'}/>
                    }

                </div>
            );
        else {
            return (<TopAlertUwaga text={'Błąd odczytu biletu'}/>)
        }
    }
}

export default BiletKodZParagonuContainer;


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/bilety_kod_z_paragonu_components/BiletKodZParagonuContainer.js